module.exports = __webpack_public_path__ + "static/media/ai-conversational.8d996726.png";